import { render, staticRenderFns } from "./cabecalho.vue?vue&type=template&id=4710f302"
import script from "./cabecalho.vue?vue&type=script&lang=js"
export * from "./cabecalho.vue?vue&type=script&lang=js"
import style0 from "./cabecalho.vue?vue&type=style&index=0&id=4710f302&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports